module.exports = __webpack_public_path__ + "img/story002.a5dd86f8.webp";